// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Plus = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Plus = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Plus = _exports.Plus = function Plus(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.0014 1.875C10.4822 1.875 10.8719 2.26475 10.8719 2.74554V17.2545C10.8719 17.7352 10.4822 18.125 10.0014 18.125C9.52061 18.125 9.13086 17.7352 9.13086 17.2545V2.74554C9.13086 2.26475 9.52061 1.875 10.0014 1.875Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.87695 10.0004C1.87695 9.51963 2.26671 9.12988 2.74749 9.12988H17.2564C17.7372 9.12988 18.127 9.51963 18.127 10.0004C18.127 10.4812 17.7372 10.871 17.2564 10.871H2.74749C2.26671 10.871 1.87695 10.4812 1.87695 10.0004Z",
      fill: "currentColor"
    }));
  };
});
